import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { TemperatureSizeSalesResponseModel } from '@/types/clarityLens/response/salesLens'

export const getTemperatureSizeSales = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string
): Promise<TemperatureSizeSalesResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-sales-lens/overview/temperature-size`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          item_group_name: itemGroupName,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
